export default "__VITE_ASSET__B8poE1cq__"